import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProgateComponent } from './simple-icons-progate.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProgateComponent ],
    exports:      [ SimpleIconsProgateComponent ],
    bootstrap:    []
})
export class SimpleIconsProgateModule {}
